// @flow
import * as React from 'react'
import styled from 'styled-components'
import { config } from 'react-awesome-styled-grid'
import { customConf } from '@components/shared/theme'

type PropsType = {
  children: React.Node
}

export default function FullBleed ({ children }: PropsType): React.Node {
  return <Container>{children}</Container>
}

const Container = styled.div`
  ${(props: any): string => config(props).media.xs`
    margin-left: -${customConf.paddingWidth.xs}rem;
    margin-right: -${customConf.paddingWidth.xs}rem;
  `}
  ${(props: any): string => config(props).media.sm`
    margin-left: -${customConf.paddingWidth.sm}rem;
    margin-right: -${customConf.paddingWidth.sm}rem;
  `}
  ${(props: any): string => config(props).media.md`
    margin-left: -${customConf.paddingWidth.md}rem;
    margin-right: -${customConf.paddingWidth.md}rem;
  `}
  ${(props: any): string => config(props).media.lg`
    margin-left: -${customConf.paddingWidth.lg}rem;
    margin-right: -${customConf.paddingWidth.lg}rem;
  `}
  ${(props: any): string => config(props).media.xl`
    margin-left: -${customConf.paddingWidth.xl}rem;
    margin-right: -${customConf.paddingWidth.xl}rem;
  `}
`
